import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "oxd-topbar-body-nav-tab-item",
  href: "#"
}
const _hoisted_2 = { class: "oxd-topbar-body-nav-tab-item" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  href: "#",
  role: "menuitem",
  class: "oxd-topbar-body-nav-tab-link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_dropdown_menu = _resolveComponent("oxd-dropdown-menu")!

  return (_ctx.menuItem.children.length === 0)
    ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickMenu($event, _ctx.menuItem)))
      }, [
        _createElementVNode("a", _hoisted_1, _toDisplayString(_ctx.menuItem.name), 1)
      ]))
    : (_openBlock(), _createBlock(_component_oxd_dropdown_menu, { key: 1 }, {
        content: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItem.children, (subMenuItem, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `nav-level2-${index}`,
              onClick: ($event: any) => (_ctx.onClickMenu($event, subMenuItem))
            }, [
              _createElementVNode("a", _hoisted_4, _toDisplayString(subMenuItem.name), 1)
            ], 8, _hoisted_3))
          }), 128))
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.menuItem.name) + " ", 1),
            _createVNode(_component_oxd_icon, {
              name: "chevron-down",
              "with-container": false
            })
          ])
        ]),
        _: 1
      }))
}